import React from 'react';
import { withTranslation } from 'react-i18next';
import './EyeColorLandingForm.css';
import ParentOneEyeDropDown from './ParentOneEyeDropDown';
import ParentTwoEyeDropDown from './ParentTwoEyeDropDown';


class EyeColorLandingForm extends React.Component {
    // Setting up component default state here
    state = {
        // genderType: this.props.heightData.genderType,
        motherHeight: 0,
        fatherHeight: 0,
        defaultMotherHeight: "",
        defaultFatherHeight: "",
        unit: 'cm',
        isToggled: false,
        defaultSelectedMotherColor: this.props.eyeColor.motherColorName === '' ? 'Select Color' : this.props.eyeColor.motherColorName,
        defaultSelectedFatherColor: this.props.eyeColor.fatherColorName === '' ? 'Select Color' : this.props.eyeColor.fatherColorName
    };

    

    // Sending default data from Child component to parent component as component loads
    componentDidMount() {
    }

    sendMotherColor = (item) => {
        this.setState({
            defaultSelectedMotherColor : item.fields.colorName
        })
        this.props.sendMotherColor(item)
    }

    sendFatherColor = (item) => {
        this.props.sendFatherColor(item)
    }

    render() {
        let { componentData } = this.props;
        return (
            <>
                <div className="form-group">
                    <label>{componentData.eyeColorLabel.value}</label>
                    <ParentOneEyeDropDown componentData={componentData} defaultSelectedColor={this.state.defaultSelectedMotherColor} sendMotherColor={this.sendMotherColor}/>
                </div>
                <div className="form-group">
                    <label>{componentData.partnerEyeColorLabel.value}</label>
                    <ParentTwoEyeDropDown componentData={componentData} defaultSelectedColor={this.state.defaultSelectedFatherColor} sendFatherColor={this.sendFatherColor}/>
                </div>
                
               
                
            </>
        )
    }
}



export default withTranslation()(EyeColorLandingForm);